// No database interaction here,
// just logic for cropping & boxing UI.

// initial state
const state = {
  coords: null,
  direction: null,
  originalClick: null,
  originalRect: null,
}

// getters
const getters = {}

// mutations
const mutations = {
  async auditImageMouseDown(st, {
    coords, crop, direction, $event,
  }) {
    state.coords = coords
    // state.direction = await this.dispatch('getDirection', { $event });
    state.direction = direction || ''
    state.originalClick = await this.dispatch('getEventXY', { $event, crop })
    state.originalRect = {
      left: coords.x,
      right: coords.x + coords.width,
      top: coords.y,
      bottom: coords.y + coords.height,
    }

    const frame = $event.target.closest('.audit-pog-image-frame')
    frame.classList.add('move')
  },

  async auditImageMouseMove(st, { $event, crop }) {
    // mouse coordinates, as fractions (same as db)
    const { x, y } = await this.dispatch('getEventXY', { $event, crop })

    switch (st.direction) {
      case null: break
      case '': {
        // no resize here, just movement
        const diff = {
          x: x - state.originalClick.x,
          y: y - state.originalClick.y,
        }
        // 0 <= x <= (1 - width), 0 <= y <= (1 - height)
        Object.assign(state.coords, {
          x: Math.max(0, Math.min(1 - state.coords.width, state.originalRect.left + diff.x)),
          y: Math.max(0, Math.min(1 - state.coords.height, state.originalRect.top + diff.y)),
        })
        break
      }
      default: {
        // resizing strategy:
        // 1. determine what shouldn't move.
        // 2. make the biggest possible rectangle while respecting #1.
        const lockedSides = {
          horiz: st.direction.includes('n') ? 'bottom' : 'top',
          vert: st.direction.includes('e') ? 'left' : 'right',
        }

        const isNS = st.direction.includes('n') || st.direction.includes('s')
        const isEW = st.direction.includes('e') || st.direction.includes('w')

        const rect = Object.assign({}, state.originalRect, !isEW ? {} : {
          left: Math.min(x, state.originalRect[lockedSides.vert]),
          right: Math.max(x, state.originalRect[lockedSides.vert]),
        }, !isNS ? {} : {
          top: Math.min(y, state.originalRect[lockedSides.horiz]),
          bottom: Math.max(y, state.originalRect[lockedSides.horiz]),
        })

        Object.assign(state.coords, {
          x: rect.left,
          y: rect.top,
          height: rect.bottom - rect.top,
          width: rect.right - rect.left,
        })
        break
      }
    }
  },

  async auditImageMouseOver(st, { $event }) {
    // don't change the cursor once it's set
    if (state.direction) return

    const frame = $event.target.closest('.audit-pog-image-frame');

    ['n', 's', 'e', 'w', 'ne', 'nw', 'se', 'sw']
      .forEach(d => frame.classList.remove(`${d}-resize`))

    const dir = await this.dispatch('getDirection', { $event })

    if (dir.length) {
      frame.classList.add(`${dir}-resize`)
    }
  },

  auditImageMouseUp(st, { $event }) {
    state.coords = null
    state.direction = null
    state.originalRect = null

    const frame = $event.target.closest('.audit-pog-image-frame')
    frame.classList.remove('move')
  },
}

// actions
const actions = {
  getDirection(context, { $event }) {
    const { clientX: x, clientY: y } = $event
    const rect = $event.target.getBoundingClientRect()

    const margin = -1 // impossible margin
    let dir = ''

    if (Math.abs(y - rect.top) < margin) {
      dir = `${dir}n`
    } else if (Math.abs(y - rect.bottom) < margin) {
      dir = `${dir}s`
    }

    if (Math.abs(x - rect.right) < margin) {
      dir = `${dir}e`
    } else if (Math.abs(x - rect.left) < margin) {
      dir = `${dir}w`
    }

    return dir
  },

  // get the absolute coordinates of an event as fractions
  getEventXY(context, { $event, crop: { scale, tx, ty } }) {
    const frame = $event.target.closest('.audit-pog-image-frame')
      .getBoundingClientRect()
    const x = (($event.clientX - frame.x) / frame.width / scale) + -(tx)
    const y = (($event.clientY - frame.y) / frame.height / scale) + -(ty)
    return { x, y }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/audit/AuditImage.js